var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msg-subscr-msanage" }, [
      _c("div", { staticClass: "hint block mb10" }, [
        _c("div", { staticClass: "title" }, [_vm._v("温馨提示")]),
        _vm._v(" "),
        _c("p", [_vm._v("逐条检查：一条一条的检查，因数据较多花费时间较长")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block mb10" }, [
        _c("p", [
          _vm._v("逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block" }, [
        _c("p", [_vm._v("导入excel文件的单元格格式推荐使用常规或文本")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-body mt10" }, [
        _c("div", { staticClass: "hint block" }, [
          _c("p", [_vm._v("合同基本信息")])
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "native-table" }, [
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("列名")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-th", staticStyle: { width: "120px" } },
              [_vm._v("是否必填")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("其他要求")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-th" }, [_vm._v("不符合要求的结果")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("买方公司")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("买方公司不可为空，可在系统中选择商户实体公司")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("合同名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("合同名称不可为空，可在系统中手动输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("合同编号")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，系统中不可手动输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("供应商名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "根据供应商统一社会信用代码自动带出，供应商必须是入选供方公司"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" })
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("卖方公司")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "卖方公司不可为空，可在系统中选择卖方商户实体公司且必须是入选供方公司"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("供应商统一社会信用代码")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，友情提示：不要填错了")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("开始时间")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中进行选择，以系统的为准")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("结束时间")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中进行选择，以系统的为准")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("签署日期")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中进行选择，以系统的为准")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("到货期限（天）")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("否")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中进行填写")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("税率(%)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中手工输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "hint block mt10" }, [
          _c("p", [_vm._v("资产信息")])
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "native-table" }, [
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("列名")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-th", staticStyle: { width: "120px" } },
              [_vm._v("是否必填")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("其他要求")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-th" }, [_vm._v("不符合要求的结果")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("合同编号")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "必填，系统中不可手动输入，必须与合同基本信息中的合同编号相同"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("资产定义编码")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中手工输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("资产名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据资产定义编码对应的资产定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" })
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("资产描述全称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据资产定义编码对应的资产定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" })
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("资产分类编码")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据资产定义编码对应的资产定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("品牌")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据资产定义编码对应的资产定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("单位")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据资产定义编码对应的资产定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("型号")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据资产定义编码对应的资产定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("规格")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据资产定义编码对应的资产定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("区域名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "可在系统中手工输入，输入后默认启动区域价格，输入后系统中找不到区域验证不通过"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("区域编码")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手工输入，输入后默认启动区域价格")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("含税价(元)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中手工输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("质保期(月)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中手工输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("经营业态")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  '可在系统中进行选择以系统的为准,可多选按"|"分割，不为空的时候，系统中找不到对应的经营业态的时候验证不通过'
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("是否可定制")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "仅可在模板中手工输入，如违反了商品是否可定制需拦截：商家商品不可定制，请修改导入文件"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "hint block mt10" }, [
          _c("p", [_vm._v("组装件信息")])
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "native-table" }, [
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("列名")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-th", staticStyle: { width: "120px" } },
              [_vm._v("是否必填")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("其他要求")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-th" }, [_vm._v("不符合要求的结果")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("合同编号")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "必填，系统中不可手动输入，必须与合同基本信息中的合同编号相同"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("组装件定义编码")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中手工输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("组装件名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据组装件定义编码对应的组装件定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" })
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("组装件描述全称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据组装件定义编码对应的组装件定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" })
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("品牌")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据组装件定义编码对应的组装件定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("单位")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据组装件定义编码对应的组装件定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("型号")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据组装件定义编码对应的组装件定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("规格")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据组装件定义编码对应的组装件定义自动带出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("区域名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "可在系统中手工输入，输入后默认启动区域价格，输入后系统中找不到区域验证不通过"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("区域编码")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手工输入，输入后默认启动区域价格")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("含税价(元)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中手工输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("质保期(月)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中手工输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("经营业态")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  '可在系统中进行选择以系统的为准,可多选按"|"分割，不为空的时候，系统中找不到对应的经营业态的时候验证不通过'
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10480630", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10480630","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractFormatExpl.vue
// module id = 3231
// module chunks = 0